export default function Footer() {
	return (
		<footer>
			<small>&copy; developed by</small>
			<a href="https://travolgi.it" target="_blank" rel="noopener noreferrer">
				<img src="/travolgi-logo.webp" alt="Travolgi logo" title="developed by Travolgi" />
			</a>
		</footer>
	);
}